module.exports = __webpack_public_path__ + "static/img/exam_6.43d4cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/exam_6.png
// module id = JZ9w
// module chunks = 1